import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { ButtonSelect } from "@/shared/Components";
import { useAppDispatch, useAppSelector } from "@/services/store";
import { selectedLangSelector } from "@/services/i18n/slice/selectors";
import { setSelectedLang } from "@/services/i18n/slice/state";
import { LANGUAGE_KEY } from "@/services/i18n/slice/types";
import { RUFlagIcon, USFlagIcon } from "@/shared/icons";
import type { Language } from "@/services/i18n/slice/types";
import type { FC } from "react";
import type { ButtonProps } from "antd/lib";
import styles from "./styles.module.scss";

export const LanguageSelect: FC<ButtonProps> = ({ className, rootClassName }) => {
  const { i18n, t } = useTranslation();
  const lngSelectOptions = [
    {
      label: (
        <label className={styles.label}>
          <RUFlagIcon />
          <div>{t("common.ru")}</div>
        </label>
      ),
      value: "ru",
    },
    {
      label: (
        <label className={styles.label}>
          <USFlagIcon />
          <div>{t("common.en")}</div>
        </label>
      ),
      value: "en",
    },
  ];

  const selectedLang = useAppSelector(selectedLangSelector);
  const dispatch = useAppDispatch();

  const changeLang = (value: string) => {
    dispatch(setSelectedLang(value as Language));
    i18n.changeLanguage(value);
    localStorage.setItem(LANGUAGE_KEY, value);
  };

  return (
    <ButtonSelect
      rootClassName={classNames(styles["select-options"], rootClassName)}
      className={classNames([styles.select, className])}
      options={lngSelectOptions}
      value={selectedLang}
      onChange={changeLang}
    />
  );
};
